import { Injectable, Injector } from '@angular/core';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { TextFilter, RangeDateFilterStore, DateFilterStore } from '../../../common-page-components/stores/filters-store/filters-store';
import { BehaviorSubject, Observable } from 'rxjs';
import { AthletePhotosStore, IPhotos } from '../../../common-page-components/stores/entities-store/athlete-photos-store';
import { HttpClient } from '@angular/common/http';
import { TeamEntriesStore } from 'src/app/common-page-components/stores/entities-store/team-entries-store';
import { AthletePhotosEventsStore } from '../../../common-page-components/stores/entities-store/athlete-photos-events';

@Injectable({
  providedIn: 'root'
})
export class FilterAthletePhotosServiceService {

  /**
   * The text filter.
   *
   * @memberof FilterAthletePhotosServiceService
   */
  textFilter = new TextFilter('text-filter');

  /**
   * The events combo for filter photos.
   *
   * @memberof FilterAthletePhotosServiceService
   */
  eventsCombo : AthletePhotosEventsStore;

  /**
   * The date filter.
   *
   * @memberof FilterAthletePhotosServiceService
   */
  rangeDate : RangeDateFilterStore;

  /**
   * The filters of the view.
   *
   * @memberof FilterAthletePhotosServiceService
   */
  filterOptions = [
  ];

  /**
   * The store of the athlete photos.
   *
   * @memberof FilterAthletePhotosServiceService
   */
  athletePhotoStore = new AthletePhotosStore(this.http);

  /**
   * Team photos entry for get the ahletes of competition in carousel detail.
   *
   * @type {TeamEntriesStore}
   * @memberof FilterAthletePhotosServiceService
   */
  photo_team_entries: TeamEntriesStore = new TeamEntriesStore(this.http, this.injector);

  constructor(
    public common_filter: FiltersAthleteGeneralService,
    public http: HttpClient,
    private injector: Injector
  ) {
    this.athletePhotoStore = this.common_filter.athletePhotoStore;
    this.eventsCombo = new AthletePhotosEventsStore('Event:', this.http, this.common_filter.athletePhotoStore.athlete_id);
    this.rangeDate = this.eventsCombo.rangeDate;
    this.eventsCombo.filterInfo.options.initial_state = true;
    this.eventsCombo.filterInfo.options.delay_time = 0;
    this.eventsCombo.athlete_id = this.common_filter.athletePhotoStore.athlete_id;
    this.eventsCombo.requestData({}, false).subscribe();
    this.rangeDate.dateRangeInfo.date_from.intercept_name = 'photos_date_from';
    this.rangeDate.dateRangeInfo.date_to.intercept_name = 'photos_date_to';
    this.rangeDate.dateRangeInfo.date_from.delay_time = 300;
    this.rangeDate.dateRangeInfo.date_to.delay_time = 300;
    this.filterOptions.unshift(this.eventsCombo.filterInfo as any, this.eventsCombo.rangeDate.filterInfo as any);
  }

  /**
   * {@inheritdoc}
   *
   * @returns
   * @memberof FilterAthletePhotosServiceService
   */
  getPhotos() {
    return this.common_filter.getPhotos();
  }

  /**
   *
   * A method for load more photos.
   * @param {*} [params] The parameters to send.
   * @memberof FilterAthletePhotosServiceService
   */
  loadMore(params?:any) {
    this.athletePhotoStore.requestData(params, true).subscribe();
  }

  areMoreData() {
    const pagination = (this.athletePhotoStore.pagination as any);
    return pagination.pages > 0 && pagination.next_page !== 0;
  }

  /**
   * Load entries of athlete team.
   *
   * @param {string} compId the competition id.
   * @memberof FilterAthletePhotosServiceService
   */
  loadAthletesEntries(compId: string) {
    return this.photo_team_entries.requestData(
      { CompId: compId, Noc: this.common_filter.athleteDetailStore.data[0].NOC },
      false);
  }
}
